<template>
  <div>
    <div v-for="(item, index) in valueComp" :key="index" class="kvass-image-text__item">
      <component
        :is="item.Component"
        class="kvass-image-text__image"
        :value="{
          ...item.image,
          url: $path('image.url', item) || item.image,
        }"
        loop
        v-bind="$attrs"
        :class="[`kvass-image-text__image-type--${item.type}`]"
      />

      <div class="kvass-image-text__content">
        <slot name="content" v-bind="item">
          <h2 class="kvass-image-text__title">{{ item.title }}</h2>
          <div class="kvass-image-text__description" v-html="item.description"></div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import Mixin from './mixin'
export default {
  mixins: [Mixin],
}
</script>

<style lang="scss">
.kvass-image-text--theme-masonry {
  column-count: 2;
  column-gap: 10rem;

  @media (max-width: 900px) {
    column-gap: 4rem;
  }

  @media (max-width: 600px) {
    column-count: 1;
  }

  .kvass-image-text__item {
    break-inside: avoid;

    & + .kvass-image-text__item {
      padding-top: 10rem;

      @media (max-width: 900px) {
        padding-top: 6rem;
      }

      @media (max-width: 600px) {
        padding-top: 3rem;
      }
    }
  }

  .kvass-image-text__image {
    max-width: 100%;
    position: relative;
    width: 100%;
    height: 100%;

    &.kvass-media-render-vimeo,
    &.kvass-media-render-youtube {
      background-color: inherit;
    }

    &-type {
      &--vimeo,
      &--youtube {
        aspect-ratio: 16/9;
      }
    }

    iframe {
      height: 100%;
      width: 100%;
    }
  }

  .kvass-image-text__content {
    margin-top: 1rem;
  }

  .kvass-image-text__title {
    margin: 0;
  }
}
</style>
